































import { Component, Vue, Emit, PropSync } from "vue-property-decorator";
import { namespace } from "vuex-class";
const storeManage = namespace("storeManage");
@Component
export default class ExportSelectDialog extends Vue {
  @storeManage.Action queryExportFieldsRest: Function;

  @PropSync("visible", { type: Boolean, default: false })
  dialogVisible: boolean;
  private isSaveLoading = false;
  private allSeleted = false;
  private isIndeterminate = true;
  private selectList: any = [];
  private allList: any = [];
  created() {
    // 获取导出项配置
    this.queryExportFieldsRest()
      .then(res => {
        this.allList = res || [];
        this.selectList = (res || [])
          .filter(o => o.defaultChoice)
          .map(_ => _.fieldCode);
      })
      .catch(err => {
        console.log(err, "导出项的配置的错误信息");
      });
  }
  @Emit("submit")
  submit() {
    if (this.selectList.length === 0) {
      this.$message.error("请选择需要导出的属性列");
      return;
    }
    const selectSortList = this.allList
      .filter(o => this.selectList.includes(o.fieldCode))
      .map(_ => _.fieldCode);
    this.dialogVisible = false;
    return selectSortList;
  }
  // 单选
  handleCheckedItemChange(val) {
    this.allSeleted = val.length === this.allList.length;
    this.isIndeterminate = val.length > 0 && val.length < this.allList.length;
  }
  // 全选
  handleCheckAllChange(val) {
    if (val) {
      this.allSeleted = true;
      this.selectList = this.allList.map(o => o.fieldCode);
      this.isIndeterminate = false;
    }
  }
}
